<style lang="less" scoped>
/deep/ .el-upload__tip {
  display: none;
}
.p20 {
  padding: 12px;
}
.el-form-item {
  width: 100%;
}
.pages-layout {
  overflow-x: hidden;
}
</style>

<template>
  <sz-page-layout handle>
    <template #handle>
      <el-button v-preventReClick v-hasAuth="'pcWorkbenchBillingCreate'" type="primary" v-if="ruleForm.flowStatus !== '07'" :loading="loading" @click="submit(false)">保存为草稿</el-button>
      <el-button v-preventReClick v-hasAuth="'pcWorkbenchBillingCreate'" type="success" v-else :loading="loading" @click="submit(false)">保存</el-button>
      <el-button v-preventReClick v-hasAuth="'pcWorkbenchBillingCreate'" type="success" :loading="loading" @click="submit(true)">提交</el-button>
      <el-button :loading="loading" @click="$router.go(-1)">返回列表</el-button>
    </template>
    <sz-card class="p20">
      <el-form ref="ruleForm" size="small" :rules="rules" :model="ruleForm" :label-position="'top'" label-width="150px" class="demo-ruleForm">
        <el-row :gutter="50">
          <el-col :span="8">
            <el-form-item label="申请单号" prop="name"> - </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请人" prop="applicant">
              <el-cascader v-model="ruleForm.applicant" disabled style="width: 100%" :options="data.treeList" :props="{
                  label: 'name',
                  value: 'code',
                }"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="单位名称">
              <el-input v-model="ruleForm.tenantName" style="width: 100%" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属项目" prop="projectId">
              <el-select v-model="ruleForm.projectId" filterable style="width: 100%" placeholder="请选择" @change="getProjectAddress()">
                <el-option v-for="item in data.projectList" :key="item.id" :label="item.projectName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目地址">
              <el-input v-model="ruleForm.projectAddress" style="width: 100%" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="8">
            <el-form-item label="付款单位" prop="customerName">
              <el-input v-model="ruleForm.customerName" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款单位纳税人识别号" prop="tfn">
              <el-input v-model="ruleForm.tfn" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款单位注册地址" prop="registerAddress">
              <el-input v-model="ruleForm.registerAddress" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款单位注册电话" prop="registerPhone">
              <el-input v-model="ruleForm.registerPhone" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款单位银行账号" prop="bankAccount">
              <el-input v-model="ruleForm.bankAccount" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款单位开户行" prop="depositBank">
              <el-input v-model="ruleForm.depositBank" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票金额" prop="invoiceAmount">
              <el-input-number v-model="ruleForm.invoiceAmount" style="width: 100%" :precision="2"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="税率" prop="tax">
              <el-select v-model="ruleForm.tax" filterable style="width: 100%" placeholder="请选择">
                <el-option v-for="item in data.taxList" :key="item.id" :label="item.dataLabel" :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票类型" prop="invoiceType">
              <el-select v-model="ruleForm.invoiceType" filterable style="width: 100%" placeholder="请选择">
                <el-option v-for="item in data.taxTypeList" :key="item.id" :label="item.dataLabel" :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="甲方单位是否确定此付款金额" prop="confirm">
              <el-select v-model="ruleForm.confirm" filterable style="width: 100%" placeholder="请选择">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票备注栏是否有特殊要求">
              <el-input v-model="ruleForm.remark" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="附件">
              <sz-upload :upload-style="'normal'" :accept="'.png,.jpg'" :disabled="disabled" :file-lists="ruleForm.files" @getResult="getUploadResultFn">
              </sz-upload>
              <!-- ruleForm.files[0].fileName ? ruleForm.files : [] -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </sz-card>
    <sz-card v-if="hxStaffDept == 'finance'" class="mt12 p20">
      <el-form :model="ruleForm" size="small" :label-position="'top'" label-width="150px" class="demo-ruleForm">
        <el-row :gutter="50">
          <el-col :span="8">
            <el-form-item label="开票日期">
              <el-date-picker v-model="ruleForm.invoiceDate" style="width: 100%" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票号码">
              <el-input v-model="ruleForm.invoiceNumber" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </sz-card>
    <sz-card :header="true" title="计划收款信息" class="mt12 p20">
      <el-form ref="collectionForm" :model="ruleForm" :rules="rules" size="small" :label-position="'top'" label-width="150px" class="demo-ruleForm">
        <el-row :gutter="50">
          <el-col :span="8">
            <el-form-item label="收款类型" prop="collectionType">
              <el-select v-model="ruleForm.collectionType" filterable style="width: 100%" placeholder="请选择">
                <el-option v-for="item in data.collectionTypeList" :key="item.dataValue" :label="item.dataLabel" :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计划收款金额" prop="planReceivedAmount">
              <el-input-number
                v-model="ruleForm.planReceivedAmount"
                placeholder="请输入计划收款金额"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="质保金是否全部完成收款" prop="whetherAll">
              <el-select v-model="ruleForm.whetherAll" filterable style="width: 100%" placeholder="请选择">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注">
              <el-input v-model="ruleForm.receivedRemark" type="textarea" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </sz-card>
    <sz-card class="mt12">
      <el-row :gutter="50">
        <el-col :span="24">
          <sz-workflow-user v-model="data.approver" class="p24" :workflow-type="'invoice_application'"></sz-workflow-user>
        </el-col>
        <el-col>
          <sz-card v-if="ruleForm.flowStatus === '07'">
            <sz-workflow-detail :process-instance-id="ruleForm.processInstanceId"></sz-workflow-detail>
          </sz-card>
        </el-col>  
      </el-row>
    </sz-card>
  </sz-page-layout>
</template>
// eslint-disable-next-line vue/component-tags-order
<script lang="ts">
import SzCard from "@/components/basics/SzCard.vue";
import {
  defineComponent,
  reactive,
  onActivated,
  ref,
  toRefs,
  computed,
} from "vue";
import $api from "@/api/main";
import { ElMessage } from "element-plus";
import utils from "@/utils/utils";
import { dayFunc } from "@/hooks/factoryFunc";
export default defineComponent({
  name:'pcWorkbenchBilling',
  components: { SzCard },
  setup(props, context) {
    const { dayjs } = dayFunc();
    let data: any = reactive({
      treeList: [],
      projectList: [],
      customerList: [],
      taxList: [],
      approver: [],
      taxTypeList: [],
      collectionTypeList:[],
    });

    const collectionForm = ref(null);

    const whetherAllValidator = (rule: any, value: any, callback: any) => {
      let model = ((collectionForm.value) as any).model;
      if(model.collectionType == '02' && (value == null || value == '')) {
        callback(new Error('请选择是否全部完成收款'));
        return
      }
      callback();
    };

    const rules = {
      tenantName: [{ required: true, message: "请输入合同名称" }],
      projectId: [{ required: true, message: "请选择所属项目" }],
      customerName: [{ required: true, message: "请选择" }],
      applicant: [{ required: true, message: "请选择" }],
      tfn: [{ required: true, message: "请输入" }],
      registerAddress: [{ required: true, message: "请输入" }],
      registerPhone: [{ required: true, message: "请输入" }],
      bankAccount: [{ required: true, message: "请输入" }],
      depositBank: [{ required: true, message: "请输入" }],
      invoiceAmount: [{ required: true, message: "请输入" }],
      tax: [{ required: true, message: "请选择" }],
      invoiceType: [{ required: true, message: "请选择" }],
      confirm: [{ required: true, message: "请选择" }],
      remark: [{ required: true, message: "请输入" }],
      collectionType: [{ required: true, message: "请选择收款类型" }],
      planReceivedAmount: [{ required: true, message: "请输入计划收款金额" }],
      //当collectionType为质保金时，whetherAll必填
      whetherAll: [{ validator: whetherAllValidator,trigger: 'blur' }]
    };

    onActivated(() => {
      //
      $api.getEmployeesTree().then((res: any) => {
        if (res) {
          data.treeList = res;
        }
      });
      $api.getProjectList().then((res: any) => {
        if (res) {
          data.projectList = res;
        }
      });
      $api.getCustomerListIng().then((res: any) => {
        if (res) {
          data.customerList = res;
        }
      });
      $api.getDir("TAX_CALCULATION_METHOD").then((res: Array<never>) => {
        data.taxList = res;
      });
      $api.getDir("COLLECTION_TYPE").then((res: Array<never>) => {
        data.collectionTypeList = res;
      });
      $api.getDir("INVOICE_TYPE").then((res: Array<never>) => {
        data.taxTypeList = res;
      });
    });
    return {
      dayjs,
      rules,
      data,
      collectionForm
    };
  },
  data() {
    return {
      hxStaffDept: utils.$cookie.getCookie("hxStaffDept"),
      ruleForm: {
        applicant: utils.$cookie.getCookie("hxUserCode"),
        tenantName: window.sessionStorage.getItem("tenantName"),
        flowStatus:'',
        projectId: "",
        customerName: "",
        tfn: "",
        registerAddress: "",
        registerPhone: "",
        bankAccount: "",
        depositBank: "",
        invoiceAmount: "",
        tax: "",
        invoiceType: "",
        confirm: "",
        remark: "",
        files: [],
        invoiceDate: "",
        projectAddress: "",
        invoiceNumber: "",
        submit: false,
        collectionType:null,
        planReceivedAmount:'',
        whetherAll:null,
        receivedRemark:''
      },
      loading: false,
    };
  },
  activated() {
    if (this.$route.query.id) {
      $api.getInvoiceInfo(this.$route.query.id).then((res: any) => {
        this.ruleForm = res;
        this.data.approver = res.approver;
      });
    }
  },
  methods: {
    getUploadResultFn(data: any) {
      this.ruleForm.files = data;
    },
    async getProjectAddress() {
      await $api.getProjectDetails(this.ruleForm.projectId).then((res: any) => {
        let customerId = res.customerId;
        $api.getCustomerDetails(customerId).then((res1: any) => {
          this.ruleForm.customerName = res1.name;
          this.ruleForm.registerAddress = res1.registerAddress;
          this.ruleForm.registerPhone = res1.registerPhone;
          this.ruleForm.bankAccount = res1.bankAccount;
          this.ruleForm.depositBank = res1.depositBank;
          this.ruleForm.projectAddress = res1.address;
          this.ruleForm.tfn = res1.tfn;
        });
      });
      this.data.projectList.forEach((item: any) => {
        if (this.ruleForm.projectId == item.id) {
          this.ruleForm.projectAddress = item.address;
        }
      });
      await $api.getLastProcessPerson({
					processDefinitionId:'invoice_application',
					projectId: this.ruleForm.projectId
				}).then((res: any) => {
					if (res && (res instanceof Array)) {
						this.data.approver = res;
					}
				});
    },
    onCancel() {
      (this as any).$store.commit('CLEAR_ROUTE','pcWorkbenchBillingList')
      this.$router.push({
        path: "/workbench/billingList",
      });
    },
    submit(submit: boolean) {
      this.ruleForm.submit = submit;
      const _this: any = this;
      if(submit){
        _this.$refs.ruleForm.validate((valid: boolean) => {
          if (valid) {
            _this.$refs.collectionForm.validate((cvalid: boolean) => {
              if(cvalid){
                if (this.data.approver.length == 0) {
                  ElMessage({
                    type: "warning",
                    message: "请选择审核流程",
                  });
                  return;
                }
                this.submitFn();
              }
            });
          }
        });
      }else{
        this.submitFn();
      }
    },
    submitFn(){
      this.loading = true;
      let { invoiceDate, ...obj } = this.ruleForm;
      if (this.$route.query.id && !this.$route.query.isReApply) {
        $api
          .upDateInvoiceMgtInfo(
            {
              ...obj,
              invoiceDate: invoiceDate
                ? this.dayjs(invoiceDate).format("YYYY-MM-DD")
                : "",
              approver: this.data.approver,
            },
            this.$route.query.id
          )
          .then((res: Array<never>) => {
            if (res) {
              ElMessage({
                type: "success",
                message: "提交成功",
              });
              (this as any).$store.commit('CLEAR_ROUTE','pcProjectFinanceManageBilling')
              this.loading = false;
              this.onCancel();
            }
          });
      } else {
        $api
          .createInvoice({
            ...obj,
            invoiceDate: invoiceDate
              ? this.dayjs(invoiceDate).format("YYYY-MM-DD")
              : "",
            approver: this.data.approver,
          })
          .then((res: Array<never>) => {
            if (res) {
              ElMessage({
                type: "success",
                message: "新增成功",
              });
              (this as any).$store.commit('CLEAR_ROUTE','pcProjectFinanceManageBilling')
              this.loading = false;
              this.onCancel();
            }
          });
      }
    },
  },
});
</script>
